import Fill from "ol/style/Fill";
import Style from "ol/style/Style";
import HexBinSource  from "ol-ext/source/HexBin"
import VectorLayer from "ol/layer/Vector";
import geostats from "geostats/lib/geostats";
import VectorSource from "ol/source/Vector";


export const hexBinMap = ({ map, featureCollection, activeLayers, setActiveLayers, selectedRadioOption }) => {
    const sizeSwiper = document.getElementById('sizeSwiper');

    const gs = new geostats();
    let legends;
    let hexBin;


    const styleFn = (feature) => {
        if(legends) {
            const range = gs.getRanges();
            
            const rangeNum = gs.getRangeNum(feature.get('features').length);
            
            const opacity = rangeNum / range.length;

            return new Style({
                fill: new Fill({
                    color: [0, 0, 255, opacity]
                })
            })
        }
    };

    const setLegends = (list) => {
        gs.setSerie(list);

        const numClasses = Math.ceil(Math.sqrt(list.length)) - 1;

        if(selectedRadioOption === "EqInterval") {
            legends = gs.getClassEqInterval(numClasses);          
        } else if (selectedRadioOption === "StdDeviation") {
            legends = gs.getClassStdDeviation(numClasses)
        } else if (selectedRadioOption === "ArithmeticProgression") {
            legends = gs.getClassArithmeticProgression(numClasses)
        } else if (selectedRadioOption === "GeometricProgression") {
            legends = gs.getClassGeometricProgression(numClasses)
        } else if (selectedRadioOption === "Quantile") {
            legends = gs.getClassQuantile(numClasses)
        } else if (selectedRadioOption === "Jenks") {
            legends = gs.getClassJenks2(numClasses)
        }

        gs.setRanges(legends);
        
    }

    const preRenderHandle = () => {
        const binSize = sizeSwiper.value;
        hexBin.setSize(binSize);

        const list = [];
        
        if(hexBin.getHexFeatures().length > 0) {
            hexBin.getHexFeatures().forEach((feature) => {
                list.push(feature.get("nb"));
            })

            setLegends(list);
        }

        map.render();
    }

    const mount = () => {
        if(activeLayers) {
            setActiveLayers();
        }
    
        const source = new VectorSource({});
    
        featureCollection.forEach((data) => {
            data.featureArray.forEach((feature) => {
                const clonedFeature = feature.clone();
                source.addFeature(clonedFeature)
            })
        });

        const binSize = sizeSwiper.value;

        hexBin = new HexBinSource({
            source: source,
            size: binSize
        })

        const list = [];

        if(hexBin.getHexFeatures().length > 0) {
            hexBin.getHexFeatures().forEach((feature) => {
                list.push(feature.get("nb"));
            })

            setLegends(list)
        }
        
        const layer = new VectorLayer({
            title: "HexBinLayer",
            source: hexBin,
            opacity: .8,
            style: styleFn,
            zIndex: 20
        });
    
        setActiveLayers([layer]);

        sizeSwiper.addEventListener('input', preRenderHandle);

        map.render();
    }

    const dismount = (key) => {
        if(sizeSwiper) {
            sizeSwiper.removeEventListener('input', preRenderHandle);
        }
        setActiveLayers();
        map.render();
    }

    return { mount: mount, dismount: dismount };
}